module.exports = __webpack_public_path__ + "img/why-icon-active-6.ee13935a.svg";